// extracted by mini-css-extract-plugin
export default {"content":"Dashboard_content__myd5A","bottom":"Dashboard_bottom__vHDp8","navItem":"Dashboard_navItem__FzF0S","label":"Dashboard_label__jdQhj","icon":"Dashboard_icon__oJ5lH"};